import type { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'

export function firstOf<T extends Array<T[0]>>(query: ReturnType<typeof useQuery<T>>) {
  return {
    ...query,
    data: computed(() => query.data.value?.[0])
  }
}
